import * as React from "react";
import Icon from "common/icons";
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";
// styles

const styles = require("./signupNavbar.scss");

interface IProps extends WrappedComponentProps {
  dispatch?: (...args: any[]) => any;
}

class SignUpNavbar extends React.PureComponent<IProps> {
  public render() {
    let titleNode: React.ReactNode;
    if (this.props.intl.locale === "ko") {
      titleNode = (
        <div className={styles.titleWrapper}>
          <Icon className={styles.vingleLogo} icon={"VINGLE_LOGO"} />
          <FormattedMessage id="signup.navbar_title" />
        </div>
      );
    } else {
      titleNode = (
        <div className={styles.titleWrapper}>
          <FormattedMessage id="signup.navbar_title" />
          <Icon className={styles.vingleLogo} icon={"VINGLE_LOGO"} />
        </div>
      );
    }

    return <nav className={styles.navWrapper}>{titleNode}</nav>;
  }
}
export default injectIntl(SignUpNavbar);
